import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import { CardType } from 'Prototype/Level/Card/CardType';
import { IGameState } from 'State/Game/IGameState';
import { Persona } from './Persona';
import { ICardData } from 'Prototype/Level/Card/ICardData';

abstract class HeuristicPlayer extends Persona {
    protected selectCardToPlay(state: IGameState, matches: string[]): [IGameState, string] {
        const cards = matches.map((match) => state.levelState.cardsState.cards[match]);
        const card = getItemByHeuristic(cards);
        return [state, card.id];
    }
}

const cardPriorities = [
    CardModifierType.tnt,
    CardType.key,
    CardType.scissors,
    CardType.plinko,
    CardType.plus_three,
    CardType.boom,
    CardType.zap,
    CardModifierType.bomb,
    CardModifierType.connected,
    CardModifierType.pickaxe,
    CardType.gold,
    CardModifierType.fog,
    CardModifierType.ice,
    CardModifierType.rising,
    CardModifierType.lowering,
    CardType.value,
    CardType.tornado,
] as const;

const HEURISTIC = new Map<string, number>(cardPriorities.map((card, index) => [card, cardPriorities.length - index]));

function getItemByHeuristic(matches: ICardData[]): ICardData {
    const cardsAndHeuristics = matches.map((match) => {
        const score = calculateHeuristicScore(match) * 10000 + calculateSecondaryScore(match);
        return { score, card: match };
    });
    cardsAndHeuristics.sort((a, b) => b.score - a.score);
    return cardsAndHeuristics[0].card;
}

function calculateHeuristicScore(match: ICardData): number {
    const modScore = match.modifiers.length > 0 ? HEURISTIC.get(match.modifiers[0].type) : 0;
    return Math.max(HEURISTIC.get(match.type), modScore);
}

function calculateSecondaryScore(match: ICardData): number {
    if (match.modifiers.find((modifier) => modifier.type === CardModifierType.bomb)) return 100 - match.modifiers[0].properties.timer;
    return match.depth;
}

export class HeuristicNoCoins extends HeuristicPlayer {
    enabled = false;
    readonly id = 'heuristicNoCoins';
    readonly playThrough = false;
}

export class HeuristicPlaythrough extends HeuristicPlayer {
    enabled = true;
    readonly id = 'heuristicPlaythrough';
    readonly playThrough = true;
}